export default "__VITE_ASSET__CErtg7iE__"